export const URLAPISUBIDA = 'https://internationallogisticsmd.com/notis/subirimg.php'
export const URLAPISUBIDAPDF = 'https://internationallogisticsmd.com/notis/subirpdf.php'
export const URLCARPETADESTINO = 'https://internationallogisticsmd.com/notis/'